import { data } from "./utils";
import ResumeFile from "../../Images/Resume_template.pdf";
export default function Resume() {
  return (
    <section className="inner-page">
      <div className="page-heading">
        <div>
          <p className="eyebrow">MY JOURNEY</p>
          <h1>
            Learning. Building.
            <br />
            <span>Moving forward.</span>
          </h1>
        </div>
        <a
          className="button"
          href={ResumeFile}
          download="Rahul_Kumar_Resume.pdf"
        >
          Download resume ↓
        </a>
      </div>
      <div className="resume-grid">
        {[
          ["Experience", data.experience],
          ["Education", data.education],
        ].map(([label, items]) => (
          <section key={label}>
            <h2 className="column-title">{label}</h2>
            <div className="timeline-list">
              {items.map((item) => (
                <article className="timeline-item" key={item.title}>
                  <span className="eyebrow">{item.date}</span>
                  <h3>{item.title}</h3>
                  <p className="institution">{item.subTitle}</p>
                  <p>{item.description}</p>
                </article>
              ))}
            </div>
          </section>
        ))}
      </div>
      <section className="achievement-section">
        <p className="eyebrow">ACHIEVEMENTS</p>
        <div className="achievement-grid">
          <article>
            <span className="section-number">01</span>
            <h3>Competitive Programming</h3>
            <p>
              50-day LeetCode streak, 1718 contest rating, and 450+ problems
              solved.
            </p>
          </article>
          <article>
            <span className="section-number">02</span>
            <h3>GATE 2026 Qualified</h3>
            <p>
              Qualified in both Computer Science and Data Science &amp;
              Artificial Intelligence.
            </p>
          </article>
        </div>
      </section>
    </section>
  );
}
